import React from "react";

import {
  AGENDA_MINUTES_PER_SLOT,
  AGENDA_PIXELS_PER_MINUTE,
} from "@whoosh/design-system/src/apps/PatronApp/screens/multiSlotBooking";
import { Box, VStack } from "@whoosh/design-system/src/components/primitive";

export const BufferSlot = ({ count }: { count: number }) => {
  return (
    <VStack
      height={AGENDA_PIXELS_PER_MINUTE * AGENDA_MINUTES_PER_SLOT * count}
      p={1}
    >
      <Box bg="grayscale-200" p={1} flex={1} borderRadius="2"></Box>
    </VStack>
  );
};
